import { Box, TextField, Typography } from '@mui/material';
import ComapnySVG from 'assets/company-reg-bg.svg';
import ButtonCustom from 'components/ButtonCustom';
import UseAuthContext from 'context/AuthContext';
import { useSnackbar } from 'notistack';
import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useMutation } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { signupOrganization } from 'services/auth-service';
import { IErrorResponse, IORGRegistrationRequest } from 'utils/contracts';
import { getErrorHtmlContent } from 'utils/utils';

const SignUP = () => {
  const [company_name, setCompanyName] = useState<string>('');
  const [company_address, setAddress] = useState<string>('');
  const [company_email, setEmail] = useState<string>('');
  const [company_phone, setPhone] = useState<string>('');
  const [isLoading, setisLoading] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { t } = useTranslation();
  const { isAuthenticated } = useContext(UseAuthContext);
  const navigate = useNavigate();
  
  // Check if user is already authenticated and redirect to home page
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/', { replace: true });
    }
  }, []);



  const SignupHandler = async (e: any) => {
    try {
      setisLoading(true);
      e.preventDefault();
      await signUpMutation.mutateAsync({
        company_name,
        company_address,
        company_email,
        company_phone,
      });
      enqueueSnackbar(t('ORGANISATION_REGISTRATION_SUCCESS_MESSAGE'), {
        variant: 'success',
      });
      setisLoading(false);
    } catch (error) {
      setisLoading(false);
    }
  };

  const signUpMutation = useMutation({
    mutationFn: async (data: IORGRegistrationRequest) => {
      const loginResponse = await signupOrganization(data);
      return loginResponse;
    },
    onSuccess(data) {
      const responseData = data.data;
      resetForm();
      return responseData;
    },
    onError(error: IErrorResponse, variables, context) {
      if (error) {
        enqueueSnackbar(getErrorHtmlContent(error), { variant: 'error' });
      }
    },
    onSettled() {
      setisLoading(false);
    },
  });

  const resetForm = () => {
    setCompanyName('');
    setAddress('');
    setEmail('');
    setPhone('');
  };

  return (
    <Box
      sx={{
        width: "100%",
        display: 'flex',
        gap: { xs: "0px", md: "0px" },
        flexDirection: { xs: 'column', md: "row-reverse" },
        alignItems: "center",
        justifyContent: 'space-between',
        mt: "50px"
      }}
    >
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          width: { xs: '100%', md: '60%' }
        }}
      >
        <Box component={"img"} sx={{ width: { xs: "250px", md: "450px" }, height: { xs: "250px", md: "450px" } }} src={ComapnySVG} alt="Company" />
      </Box>

      <Box sx={{
        display: 'flex',
        flexDirection: 'column',
        width: { xs: "100%", md: "500px" },
        alignItems: 'flex-start',
        justifyContent: 'center',
        alignSelf: 'center',
      }}>
        <Box
          sx={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            mb: "30px",
            mt: { xs: "50px", md: "0px" }
          }}
        >
          <Typography variant='h1' >{t('SIGNUP_HEADER')}</Typography>
        </Box>

        <Box component='form' style={{ width: '100%' }} className='tab-content-form'>
          <TextField
            fullWidth
            variant='standard'
            id='company_name'
            name='company_name'
            autoFocus
            label={t('SIGNUP_BUSINESS_NAME')}
            helperText={t('SIGNUP_BUSINESS_NAME_HELPTEXT')}
            autoComplete='off'
            autoCorrect='off'
            value={company_name}
            onChange={(e) => setCompanyName(e.target.value)}
          />
          <TextField
            variant='standard'
            fullWidth
            name='address'
            label={t('SIGNUP_ADDRESS')}
            helperText={t('SIGNUP_ADDRESS_HELPTEXT')}
            id='address'
            type='address'
            autoComplete='off'
            autoCorrect='off'
            value={company_address}
            onChange={(e) => setAddress(e.target.value)}
          />
          <TextField
            variant='standard'
            fullWidth
            name='email'
            label={t('SIGNUP_EMAIL')}
            helperText={t('SIGNUP_EMAIL_HELPTEXT')}
            id='email'
            dir="ltr"
            sx={{ textAlign: 'left' }}
            type='email'
            autoComplete='off'
            autoCorrect='off'
            value={company_email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <TextField
            variant='standard'
            fullWidth
            name='phone'
            label={t('SIGNUP_PHONE')}
            helperText={t('SIGNUP_PHONE_HELPTEXT')}
            id='phone'
            dir="ltr"
            sx={{ textAlign: 'left' }}
            autoComplete='off'
            autoCorrect='off'
            value={company_phone}
            onChange={(e) => setPhone(e.target.value)}
          />
          <ButtonCustom
            color='primary'
            type='submit'
            variant='contained'
            onClick={SignupHandler}
            disabled={isLoading}
          >
            {t('SIGNUP_PHONE_BUTTON')}
          </ButtonCustom>
        </Box>
      </Box>
    </Box>
  );
};

export default SignUP;
